import React from 'react';
import '../../styles/services.css';
import { FaCode, FaPaintBrush, FaBrain, FaCloud, FaMobileAlt, FaChartBar, FaHandsHelping, FaUsers} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const servicesData = [
  {
    title: 'Custom Software Development',
    description: 'Tailored software solutions for businesses across industries, built for performance and scalability.',
    icon: <FaCode />,
    route: '/services/custom-software',
  },
  {
    title: 'UI/UX Design',
    description: 'Human-centric and modern interfaces to enhance user engagement and product usability.',
    icon: <FaPaintBrush />,
    route: '/services/ui-ux',
  },
  {
    title: 'AI/ML Solutions',
    description: 'From OCR to Computer Vision — we build AI-powered systems to automate, predict, and improve outcomes.',
    icon: <FaBrain />,
    route: '/services/ai-ml',
  },
  {
    title: 'Cloud & DevOps Services',
    description: 'We deploy, manage, and optimize cloud infrastructure using AWS, Azure, and DevOps pipelines.',
    icon: <FaCloud />,
    route: '/services/cloud-devops',
  },
  {
    title: 'Web & Mobile Applications',
    description: 'Interactive, high-performance apps using React, Flutter, Node.js and more.',
    icon: <FaMobileAlt />,
    route: '/services/web-mobile',
  },
  {
    title: 'Data Analytics & BI',
    description: 'Transform data into insights with dashboards, visualization, and predictive analytics.',
    icon: <FaChartBar />,
    route: '/services/data-analytics',
  },
  {
    title: 'IT Consulting & Strategy',
    description: 'Expert advisory services to align IT strategy with business goals, driving transformation.',
    icon: <FaHandsHelping />,
    route: '/services/it-consulting',
  },
  {
  title: 'Human Resources ',
  description: 'Hire our expert developers, testers, DevOps engineers, and designers to achieve your short-term and long-term goals. Save costs without compromising on quality by leveraging our skilled professionals.',
  icon: <FaUsers />,
  route: '/services/human-resources',
},
  {
  title: 'Maintenance & Support',
  description: 'Ensure your software remains up-to-date and fully functional with our ongoing maintenance and support services. We provide timely updates, bug fixes, and technical assistance to keep your software running smoothly.',
  icon: <FaHandsHelping />,
  route: '/services/maintenance',
}

  
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="services-container"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h1 className="services-title">Our Services</h1>
      <p className="services-subtitle">Empowering your vision with innovative technology solutions.</p>

      <div className="services-grid">
        {servicesData.map((service, index) => (
          <motion.div
            key={index}
            className="service-card"
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 300 }}
            onClick={() => navigate(service.route)}
            style={{ cursor: 'pointer' }}
          >
            <div className="service-icon">{service.icon}</div>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Services;
